import React from 'react';

import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

const ExteriorSignageQuoteTermConditions = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h1" sx={{ mb: 3 }}>
        {t('termsConditions')}
      </Typography>
      <span
        dangerouslySetInnerHTML={{
          __html: t('exteriorSignageQuoteTermsConsiditonsTitle'),
        }}
      />
      <ul style={{ paddingLeft: '2rem', listStyleType: 'upper-greek' }}>
        <li>
          <span
            dangerouslySetInnerHTML={{
              __html: t('exteriorSignageQuoteTermsConsiditonsLi1'),
            }}
          />
        </li>
        <li>
          <span
            dangerouslySetInnerHTML={{
              __html: t('exteriorSignageQuoteTermsConsiditonsLi2'),
            }}
          />
        </li>
        <li>
          <span
            dangerouslySetInnerHTML={{
              __html: t('exteriorSignageQuoteTermsConsiditonsLi3'),
            }}
          />
        </li>
        <li>
          <span
            dangerouslySetInnerHTML={{
              __html: t('exteriorSignageQuoteTermsConsiditonsLi4'),
            }}
          />
        </li>
        <li>
          <span
            dangerouslySetInnerHTML={{
              __html: t('exteriorSignageQuoteTermsConsiditonsLi5'),
            }}
          />
        </li>
      </ul>
    </Box>
  );
};

export default ExteriorSignageQuoteTermConditions;
